import lightTheme from './light-theme';

export { lightTheme };

export default lightTheme;
